import * as THREE from 'three'

export default class Resizer {
    constructor(parent) {

        this.experience = new Experience();
        this.eventBus = this.experience.eventBus;
        this.minimumHeight = 600; //used by camera and renderer for maintaining minimum scene size

        this.parent = parent;
        this.callback = this.resize.bind(this);
        this.pixelRatio = Math.min(window.devicePixelRatio, 2);

        // ResizeObserver catches parent size changes (panel toggle, layout shifts, etc.)
        this.resizeObserver = new ResizeObserver(this.callback);
        this.resizeObserver.observe(this.parent);

        // Window resize & focus still needed for device pixel ratio changes and tab switches
        window.addEventListener('resize', this.callback);
        window.addEventListener('focus', this.callback);
        this.resize();
    }

    current() {
        return [this.left, this.top, this.currentWidth, this.currentHeight, this.pixelRatio];
    }

    currentAspectRatio() {
        return this.currentWidth / this.currentHeight;
    }

    resize() {
        const current = this.current();
        this.bounds = this.parent.getBoundingClientRect();
        this.left = this.bounds.left;
        this.top = this.bounds.top;
        this.currentWidth = this.bounds.width;
        this.currentHeight = this.bounds.height;

        const changed = this.current();
        if (current !== changed) {
            this.eventBus.pushLocal('resize', { width: this.currentWidth, height: this.currentHeight, pixelRatio: this.pixelRatio });
        }
    }

    mapClientPos(client) {
        const pos = new THREE.Vector2()
        pos.x = this.mapClientX(client.x);
        pos.y = this.mapClientY(client.y);
        return pos;
    }

    mapClientX(clientX) {
        return ((clientX - this.left) / this.currentWidth) * 2 - 1; //threejs uses NDC thats why we *2 -1 afte rnormalising so we get [-1,1]
    }

    mapClientY(clientY) {
        const effectiveHeight = this.currentHeight <= this.minimumHeight ? 600 : this.currentHeight;
        return -((clientY - this.top) / effectiveHeight) * 2 + 1;
    }

    destroy() {
        this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.callback);
    }
}
